import { useMutation } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { NOTIFICATION_TYPES } from '../../../../../config/consts/commons';
import { setOrdersToRetrieveFilters } from '../../../orderSlice';
import { toReceiveFromWarecloud } from '../../infra/api';
import { setMessage } from '../../../../toasts/toastSlice';
import { handleAxiosErrorMessage } from '../../../../../utils';

export default function useToReceiveFromWarecloud() {
  const { t } = useTranslation(['system']);
  const { ordersToRetrieveFilters } = useSelector((state) => state.orders);
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: ['postReceiveFromWarecloud'],
    mutationFn: ({ order_code, id_order, ...payload }) =>
      toReceiveFromWarecloud({ id_order, ...payload }),
    onSuccess: (_, { order_code }) => {
      dispatch(
        setMessage({
          body: t('ORDER_WITHDRAW_SUCCESS', {
            ns: 'system',
            order: order_code,
          }),
          type: NOTIFICATION_TYPES.SUCCESS,
        })
      );
      dispatch(setOrdersToRetrieveFilters({ ...ordersToRetrieveFilters }));
    },
    onError: (error) => {
      const errorMessage = handleAxiosErrorMessage(error);
      dispatch(
        setMessage({
          body: t(errorMessage, { ns: 'system' }),
          type: NOTIFICATION_TYPES.ERROR,
        })
      );
    },
  });
}
